import Box from '@mui/material/Box';
import { Text } from '@sitecore-jss/sitecore-jss-nextjs';
import CircularProgressBar from '../../components/shared/ProgressBar/CircularProgressBar';
import { StSubTitle } from './RegistrationWorkflow.style';
import RegWorkflowButtons from './RegWorkflowButtons';
import UiHeading from '../../components/shared/Heading';
import { RegisterMergeText } from './RegistrationMergeFields';
import UiText from '../shared/Typography/UiText';

const RegWorkflowFactory = (props: any): JSX.Element => {
  const minHeight =
    (props?.view &&
      (props.view === 'device' ? '360px' : props?.view === 'tablet' ? '400px' : '475px')) ||
    '400px';
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        gap: '2rem',
        paddingBlock: '2rem',
      }}
    >
      <UiHeading size="h2" align="center" isChildren>
        <RegisterMergeText field={props?.title} />
      </UiHeading>
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'flext-start',
          minHeight: minHeight,
          // maxHeight: '600px',
          maxWidth: '500px',
        }}
      >
        {props?.subTitle && (
          <StSubTitle sx={{ textAlign: 'center' }}>
            <UiText color="default" styles={{ fontSize: 'inherit' }}>
              <Text field={props?.subTitle} />
            </UiText>
          </StSubTitle>
        )}
        <Box sx={{ alignSelf: 'center', marginBlock: '4rem' }}>
          <CircularProgressBar currentPage={props?.currentPage} totalCount={props?.totalCount} />
        </Box>
        <Box>{props.children}</Box>
      </Box>
      <RegWorkflowButtons
        enableNext={props?.enableNext}
        buttonItems={props?.buttonsItems}
        handleClick={props.handleClick}
      />
    </Box>
  );
};

export default RegWorkflowFactory;
